import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/dongleUserModuleManage',
  name: 'dongleUserModule',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/dongleUserModuleManage',
      component: () => import('@/views/operation/dongleUserModuleManage'),
      meta: {
        title: '加密狗设置',
        icon: 'blocks-and-arrows'
      }
    },
    {
      path: '/application/identAuth/dongleUserModuleManage/moduleDetail/:id',
      component: () => import('@/views/operation/dongleUserModuleManage/info'),
      meta: {
        title: '加密狗版本详情'
      }
    }
  ]
}
